function appointmentPopup() {
  Calendly.showPopupWidget(
    "https://calendly.com/lizunova-fine-jewels?primary_color=0069ff&text_color=0a2540&branding=true"
  );
  return false;
}

document.addEventListener("DOMContentLoaded", function () {
  const bookBtns = document.querySelectorAll('[href="#book-appointment"]');

  bookBtns.forEach(function (bookBtn) {
    bookBtn.addEventListener("click", function (e) {
      e.preventDefault();
      appointmentPopup();
    });
  });
});

// Custom Popup Form
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".lz-contact-modal");
  const closeModal = modal.querySelector(".lz-close-modal");
  const subjectInput = modal.querySelector("#enquiry-subject");

  // Loop through all .enquire-button elements
  document.querySelectorAll(".enquire-button").forEach(function (enquireBtn) {
    enquireBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const productTitle = this.dataset.productTitle;
      if (subjectInput && productTitle) {
        subjectInput.value = "Enquiry – " + productTitle;
      }

      modal.style.display = "block";
      document.body.classList.add("lz-modal-open");
    });
  });

  // Close modal
  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
    document.body.classList.remove("lz-modal-open");
  });

  // Close modal when clicking outside
  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
      document.body.classList.remove("lz-modal-open");
    }
  });
});

// Colour and Shape Filter
document.addEventListener("DOMContentLoaded", function () {
  document.querySelector('.shopify-section--main-collection').addEventListener("click", function (element) {

    let label = '';

    if (element.target.classList.contains("apply_color_shape")) {
      label = element.target;
    } else if (element.target.closest.classList.contains("apply_color_shape")) {
      label = element.target.closest.classList.contains("apply_color_shape");
    }

    const filterForm = document.querySelector(
      "form.facets"
    );

    console.log("targeted", label);

    if (label) {

      const inputIdentity = label.classList.contains("apply-colour-filter") ? "color" : "shape";

      const labelValue = label.getAttribute("data-value");
      
      document.body.classList.add("applying-color-shape");

      const facetOpener = document.querySelector(
        'button[aria-controls="facets-drawer"]'
      );
      facetOpener.click();

      const viewButton = document.querySelector(
        "#facets-drawer dialog-close-button button"
      );
      if (viewButton) {
        console.log("viewButton", viewButton);

        // Trigger update input by double click
        document.querySelector('.accordion.more-filters input').click();
        document.querySelector('.accordion.more-filters input').click();

        // Clear form filterForm 
        filterForm.querySelectorAll("input[name='filter.p.tag']").forEach(input => {
          input.remove();
        });


        // Colour Input
        if (inputIdentity === "color") {
          const colorInput = document.createElement("input");
          colorInput.type = "text";
          colorInput.name = "filter.p.tag";
          colorInput.value = labelValue || '';
          filterForm.appendChild(colorInput);

          // Add existing Shape
          let existingShapeInput = document.querySelector(".apply-shape-filter.lz-active-facets");
          console.log("existingShapeInput", existingShapeInput);
          if (existingShapeInput) {
            const existingShapeValue = existingShapeInput.getAttribute("data-value");

            const shapeInput = document.createElement("input");
            shapeInput.type = "text";
            shapeInput.name = "filter.p.tag";
            shapeInput.value = existingShapeValue || '';
            filterForm.appendChild(shapeInput);

            console.log("existingShapeValue", existingShapeValue);
          }
        }
      

        // Shape input
        if (inputIdentity === "shape") {
          const shapeInput = document.createElement("input");
          shapeInput.type = "text";
          shapeInput.name = "filter.p.tag";
          shapeInput.value = labelValue || '';
          filterForm.appendChild(shapeInput);

          // Add existing Color
          let existingColorInput = document.querySelector(".apply-colour-filter.lz-active-facets");
           console.log("existingColorInput", existingColorInput);
          if (existingColorInput) {
            const existingColorValue = existingColorInput.getAttribute("data-value");
            const colorInput = document.createElement("input");
            colorInput.type = "text";
            colorInput.name = "filter.p.tag";
            colorInput.value = existingColorValue || '';
            filterForm.appendChild(colorInput);

            console.log("existingColorValue", existingColorValue);
          }
        }
  
        // APply the filter
        setTimeout(function () {
          viewButton.click();
        }, 100);

        // Remove the class after 1.5 seconds
        setTimeout(function () {
         document.body.classList.remove("applying-color-shape");
        }, 1500);


      }
    }
  });
});


